import { TableColumn } from '../../enums/TableColumn';
import type { DrivingTimesDisplayItem } from '../../tables/drivingtimes/types';
import type { AssetItem, Driver } from '../redux/types';
import { getDriverNameOfDriverId } from './driverService';
import { getVehicleNameOfAssetId } from './vehicleService';

export const addDriverAndAssetInfoToDisplayItem = (
    displayItems: DrivingTimesDisplayItem[],
    vehicles: AssetItem[],
    drivers: Driver[]
): DrivingTimesDisplayItem[] =>
    displayItems.map(displayItem => {
        const driverName = getDriverNameOfDriverId(displayItem.driverId, drivers);
        return {
            ...displayItem,
            [TableColumn.VEHICLE]: getVehicleNameOfAssetId(displayItem.assetId, vehicles),
            [TableColumn.DRIVER]: driverName ? driverName : displayItem[TableColumn.DRIVER],
        };
    });
